function initiateProfessionalSignatureStep(professionalSignature) {
  const { imageName, imageURI, professional } = professionalSignature;

  return {
    imageName,
    imageURI,
    professional
  };
}

export { initiateProfessionalSignatureStep };
